import { createHookContext } from '@clover-util/react-context';
import { useFeatureFlagsContext } from 'components/FeatureFlags/FeatureFlags';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export const { useSubscriptionsToggleOrder, SubscriptionsToggleOrderProvider } = createHookContext(
  'SubscriptionsToggleOrder',
  () => {
    const [localFirstPricingParam, setLocalFirstPricingParam] = useState<string | null>(null);
    const { isFlagEnabled } = useFeatureFlagsContext();
    const isSubscriptionsToggleOrderEnabled = isFlagEnabled('subscriptions-toggle-order');

    const { search } = useLocation();
    const firstPricingParam = new URLSearchParams(search).get('firstPricing');

    /** Store param value in context once if it is provided via URL */
    if (firstPricingParam && !localFirstPricingParam) {
      setLocalFirstPricingParam(firstPricingParam);
    }

    const isUpfrontForcedFromParam = localFirstPricingParam === 'UPFRONT';
    const isMonthlyForcedFromParam = localFirstPricingParam === 'MONTHLY';

    if (isUpfrontForcedFromParam) {
      return {
        isMonthlyFirst: false,
      };
    }

    if (isMonthlyForcedFromParam) {
      return {
        isMonthlyFirst: true,
      };
    }

    return {
      isMonthlyFirst: isSubscriptionsToggleOrderEnabled,
    };
  },
);
